import React, { Component } from 'react'
import {Table} from 'react-bootstrap'
import { t } from '../../helpers/translate'
export default class BeneficiaryEstateTable extends Component {

  constructor(props) {
    super(props)
  }

  render() {
    const {beneficiaries, beneficiary_option} = this.props;
    if(!beneficiaries.length || beneficiary_option ==='yes') return null
    return (
      <Table striped condensed hover id='paymentHistoryTable'>
        <thead>
          <tr>
            <th>{t("First Name")}</th>
            <th>{t("Last Name")}</th>
            <th>{t("Email")}</th>
            <th>{t("Relationship")}</th>
            <th>{t("Payout")} (%)</th>
          </tr>
        </thead>
        <tbody>
          {this.props.beneficiaries.map((beneficiary, index) => (
            <tr key={index}>
              <td>{beneficiary.first_name}</td>
              <td>{beneficiary.last_name}</td>
              <td>{beneficiary.email}</td>
              <td>{beneficiary.relationship}</td>
              <td>{beneficiary.payout}</td>
            </tr>
          ))}
        </tbody>
      </Table>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/common/BeneficiaryEstateTable.js